import { Text } from "@chakra-ui/react";

const Subtitle2 = ({ children, ...rest }) => (
  <Text
    fontWeight={500}
    fontSize="1.2rem"
    letterSpacing="0.4px"
    lineHeight="1.33"
    {...rest}
  >
    {children}
  </Text>
);
export default Subtitle2;
